


 //Code for Recharge redirect to payment method update
(function () {
  function toRelativePath(p) {
    if (!p) return '/';
    try {
      // If it’s a full URL, reduce to path+query+hash
      const u = new URL(p, location.origin);
      p = u.pathname + u.search + u.hash;
    } catch (_) {}
    // Must be relative path for Shopify
    if (!p.startsWith('/')) p = '/' + p;
    return p;
  }
 
  function extractIntendedPath(href) {
    const u = new URL(href, location.origin);
 
    // Try common params (Recharge often uses checkout_url)
    const candidate =
      u.searchParams.get('return_to') ||
      u.searchParams.get('checkout_url') ||
      u.searchParams.get('return_url') ||
      u.searchParams.get('redirect');
 
    // decode if it’s percent-encoded
    let decoded = candidate;
    try { decoded = decodeURIComponent(candidate); } catch (_) {}
 
    return toRelativePath(decoded);
  }
 
  document.addEventListener('click', function (e) {
    // Only act on the Recharge Affinity login page
    if (!location.pathname.startsWith('/tools/recurring/login')) return;
 
    const a = e.target.closest('a[href]');
    if (!a) return;
 
    // Pick up links that go to Shopify login routes
    const href = a.getAttribute('href') || '';
    const looksLikeLogin =
      href.includes('/account/login') ||
      href.includes('/customer_authentication/login');
 
    if (!looksLikeLogin) return;
 
    e.preventDefault();
 
    const intended = extractIntendedPath(a.href);
 
    // IMPORTANT: use storefront login so return_to is honored
    location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(intended));
  }, true);
})();


(function () {
  function hideHavingIssues() {
    const link = document.querySelector('#not_verified a[href*="/tools/recurring/get-subscription-access"]');
    const card = link && link.closest('.rc_title-bar');
    if (card) card.style.setProperty('display', 'none', 'important');
  }
 
  hideHavingIssues();
  new MutationObserver(hideHavingIssues).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  const LOGIN_REDIRECT_RE = /^\/tools\/recurring\/login\/redirect\/[^/]+\/?$/;
  const FLAG = 'rc_shop_signin_cleaned_v1';
 
  
  if (!LOGIN_REDIRECT_RE.test(location.pathname)) return;
 
  const url = new URL(location.href);
 
  // If Shop sign-in added this param, remove it once
  if (url.searchParams.get('shop_sign_in') === 'true' && sessionStorage.getItem(FLAG) !== '1') {
    sessionStorage.setItem(FLAG, '1');
    url.searchParams.delete('shop_sign_in');
    location.replace(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : ''));
    return;
  }
})();